import { render, staticRenderFns } from "./WsFlexGalleryItem.vue?vue&type=template&id=42a3b650&"
import script from "./WsFlexGalleryItem.vue?vue&type=script&lang=js&"
export * from "./WsFlexGalleryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports